<template>
    <form @submit.prevent="register" method="POST" role="form" autocomplete="off">
        <div class="form-group">
            <label for="signup-firstname">{{trans('auth.FirstName','First Name')}}</label>
            <input autocomplete="off"
                   v-model="register_form.first_name"
                   id="signup-firstname"
                   name="first_name"
                   type="text"
                   :class="submitted && !register_form.first_name ? 'error' : ''"
                   class="form-control">
            <span class="text-danger" v-if="submitted && !register_form.first_name">{{trans('step5.req_mxg','This field is required')}}</span>
        </div>
        <div class="form-group">
            <label for="signup-lastname">{{trans('auth.LastName','Last Name')}}</label>
            <input autocomplete="off"
                   v-model="register_form.last_name"
                   id="signup-lastname"
                   name="lastname"
                   type="text"
                   :class="submitted && !register_form.last_name ? 'error' : ''"
                   class="form-control">
            <span class="text-danger" v-if="submitted && !register_form.last_name">{{trans('step5.req_mxg','This field is required')}}</span>
        </div>
        <div class="form-group">
            <label for="signup-email">Email</label>
            <input autocomplete="off"
                   v-model="register_form.email"
                   id="signup-email"
                   name="email"
                   type="email"
                   :class="submitted && !register_form.email ? 'error' : ''"
                   class="form-control">
            <span class="text-danger" v-if="submitted && !register_form.email">{{trans('step5.req_mxg','This field is required')}}</span>
        </div>
        <div class="form-group">
            <label for="signup-password">{{trans('auth.Password','Password')}}</label>
            <input name="password" v-model="register_form.password"
                   autocomplete="new-password"
                   type="password" id="signup-password"
                   :class="submitted && !register_form.password ? 'error' : ''"
                   class="form-control">
            <span class="text-danger" v-if="submitted && !register_form.password">{{trans('step5.req_mxg','This field is required')}}</span>
            <span class="sub-text">{{trans('auth.psw_desc','Must be 8+ characters, with uppercase, lowercase, numbers, and symbols.')}}</span>
        </div>
        <div class="form-group">
            <label for="password_confirmation">{{trans('auth.ReTypePassword','Re Type Password')}}</label>
            <input name="password_confirmation"
                   v-model="register_form.password_confirmation"
                   id="password_confirmation" type="password"
                   :class="submitted && !register_form.password_confirmation ? 'error' : ''"
                   class="form-control">
            <span class="text-danger" v-if="submitted && !register_form.password_confirmation">{{trans('step5.req_mxg','This field is required')}}</span>
        </div>
        <div class="form-check-inline">
            <label for="is_subscribed" class="checkbox-inline">
                <input name="is_subscribed" v-model="register_form.is_subscribed" id="is_subscribed" type="checkbox" value="1" class="form-check-input">
                {{trans('auth.newsletter_info',"Subscribe to Black Tie's newsletter to get all the latest information and deals!")}}
            </label>
        </div>
        <button type="submit" class="btn btn-blue btn-block">{{trans('auth.StartBooking','Start Booking')}}</button>

        <!-- Social Sign-Up Buttons -->
        <div class="social-signup-buttons m-t-20">
            <button @click="socialLogin('google')" type="button" class="btn btn-block btn-google btn-lg m-t-10">
                <img src="/assets/images/google-icon.svg" style="width: 25px; height: 25px"> {{trans('auth.SignGoogle','Continue with Google')}}
            </button>
<!--            <button @click="socialLogin('apple')" type="button" class="btn btn-block btn-apple btn-lg m-t-10">-->
<!--                <img src="/assets/images/apple-logo.svg" style="width: 25px; height: 25px"> {{trans('auth.SignApple','Continue with Apple')}}-->
<!--            </button>-->
        </div>
    </form>
</template>
<script>
import {mapState} from "vuex";
import DataService from "../services/DataService";
export default {
    name: 'SignupForm',
    computed:{
        ...mapState(['form', 'isLoading', 'renters']),
    },
    data(){
        return {
            submitted: false,
            register_form: {
                'first_name': '',
                'last_name': '',
                'email': '',
                'password': '',
                'password_confirmation': '',
                'is_subscribed': false,
            },
        }
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        socialLogin(provider) {
            let _this = this;
            const width = 600;
            const height = 600;
            const left = (screen.width / 2) - (width / 2);
            const top = (screen.height / 2) - (height / 2);

            const popup = window.open(
                '/front_api/auth/login/'+provider,
                provider+' Login',
                `width=${width},height=${height},top=${top},left=${left}`
            );

            const checkLocalStorage = setInterval(function() {
                const socialData = localStorage.getItem('socialData') && JSON.parse(localStorage.getItem('socialData'));
                if(socialData){
                    _this.afterLogin(socialData.user, socialData.access_token);
                    localStorage.removeItem('socialData');
                    clearInterval(checkLocalStorage);
                }

            }, 1000); // Check every second

        },
        register() {
            let _this = this;
            _this.submitted = true;
            if (!_this.register_form.first_name || !_this.register_form.last_name || !_this.register_form.email
                || !_this.register_form.password || !_this.register_form.password_confirmation) {
                return false;
            } else {
                _this.$store.dispatch('setLoading', {'loading': true});
                DataService.register(this.register_form)
                    .then(res => {
                        _this.register_form = {
                            'first_name': '',
                            'last_name': '',
                            'email': '',
                            'password': '',
                            'password_confirmation': '',
                            'is_subscribed': false,
                        };
                        _this.$store.dispatch('setLoading', {'loading': false});

                        _this.afterLogin(res.data.data.user, res.data.data.access_token);

                    })
                    .catch(err => {
                        _this.$store.dispatch('setLoading', {'loading': false});
                        const errMsg = err.response ? err.response.data.message : err;
                        swal({
                            title: "Error!",
                            text: err.response.data.message,
                            // type: "error",
                            imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                            showConfirmButton: true
                        });
                        this.captureSentryEvent(errMsg)
                    })

            }
        },

        afterLogin(user, token) {
            let _this = this;
            _this.setAccessToken(token);
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('getToken')
            _this.setUser(user);
            _this.clearLocalStorage();
            this.$store.state.auth_user = this.getUser();
            if(user){
                this.form.first_name = user.first_name;
                this.form.last_name = user.last_name;
                this.form.lang = user.lang;
                this.form.email = user.email;
                this.form.phone = user.phone;
                this.form.dial_code =  user.dial_code;
            }

            $('.close').click();
            let prevUrl = document.referrer ? new URL(document.referrer) : null;
            let prev_origin = prevUrl ? prevUrl.origin : null;
            let my_origin = window.location.origin;
            if (my_origin && prev_origin && my_origin !== prev_origin) {
                if(_this.$route.name !== 'Step3'){
                    NProgress.start();
                    _this.$router.push({name: 'Step3'})
                }

            }  else if(this.renters.length < 1 && _this.$route.name === 'Login'){
                if(_this.$route.name !== 'Step1'){
                    NProgress.start();
                    _this.$router.push(_this.$store.getters.getStep1Route);
                }

            }else{
                if(_this.$route.name !== 'Step3' && _this.$route.name === 'Login'){
                    NProgress.start();
                    _this.$router.push({name: 'Step3'})
                }
            }
        },

    }
}
</script>
<style scoped>
.error {
    border: 1px solid red !important;
}
</style>
